import { defineStore } from 'pinia'
import { cesiumConfig } from '@/config/cesium.config'

export const cameraStore = defineStore('camera', {
  state: () => ({
    isTrackingDrone: false,
    showFPV: false,
    trackingOffset: {
      distance: cesiumConfig.cameraTracking.distance,
    },
    cameraControls: {
      cameraMode: null,
      exposureMode: null,
      focusMode: null,
      activeLens: null,
      isRecording: false,
      zoomAmnt: null,
    },
    exposureValues: {
      exposure: null,
      iso: null,
      shutterSpeed: null,
    },
    gimbalControls: {
      tiltVal: null,
      rollVal: null,
      panVal: null,
    },
    gimbalIgnore: {
      tilt: true,
      pan: true,
      roll: true,
    },
  }),
  actions: {
    updateTrackingOffset(offset: { distance?: number }) {
      if (offset.distance !== undefined) this.trackingOffset.distance = offset.distance
    },
    resetTrackingOffset() {
      this.trackingOffset.distance = cesiumConfig.cameraTracking.distance
    },
  },
})
